import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Modal } from 'components/atoms/modal';
import { Label01 } from 'components/styles';
import { useProjectConvParams } from '../../../../proj-conversation-hooks';
import { AddMembersForm } from '../add-members-form';

interface Props {
  isVisible: boolean;
  conversationName: string;
  onCancel: () => void;
}

const ConvName = styled.div`
  ${Label01};
  color: var(--gray-80);
`;

export const NewConversationAddMembersModal: FC<Props> = ({
  isVisible,
  conversationName,
  onCancel,
}) => {
  const [projectId, activeConversationId] = useProjectConvParams();

  return (
    <Modal
      width={462}
      visible={isVisible}
      confirmLoading={false}
      onCancel={onCancel}
      footer={null}
      title={
        <>
          <div>
            <FormattedMessage id="projects.conversations.members.add_people" />
          </div>
          <ConvName>{conversationName}</ConvName>
        </>
      }
      maskClosable={false}
      keyboard={false}
    >
      {projectId && activeConversationId ? (
        <AddMembersForm
          onSuccess={onCancel}
          projectId={projectId}
          activeConversationId={activeConversationId}
        />
      ) : null}
    </Modal>
  );
};
